<div class="full-layout {{ _workflowService?.isWorkflowOpened && 'lighter-bg' }}" #screen *ngIf="isHeader">
  <app-header></app-header>
  <div id="wrapper" class="h-100 d-flex">
    <app-sidebar (toggleClick)="toggleClick($event)"></app-sidebar>
    <div class="content-wrapper w-100" [ngClass]="getClassForMainContainer()">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<!-- Global: dynamic-sync "Remmi may feel slow" banner (WS type: dynamic-sync-banner) -->
<div class="dynamic-sync-banner" *ngIf="showSyncBanner && isHeader" role="status" aria-live="polite">
  <span class="dynamic-sync-banner__badge">
    <i class="pi pi-sync dynamic-sync-banner__icon" aria-hidden="true"></i>
  </span>
  <div class="dynamic-sync-banner__content">
    <span class="dynamic-sync-banner__title">{{ syncBannerTitle }}</span>
    <span class="dynamic-sync-banner__message">{{ syncBannerMessage }}</span>
  </div>
  <button type="button" class="dynamic-sync-banner__close" (click)="closeSyncBanner()" aria-label="Dismiss">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
</div>

<!-- Global: header help launches tours via HelpWalkthroughRunnerService on any route under this layout -->
<app-help-walkthrough-overlay *ngIf="isHeader"></app-help-walkthrough-overlay>

<!-- Global: Remmi Releases "New feature in Remmi" window and "What's New" history drawer. Opened from
     module banners, the header profile menu and the Settings preview via RemmiReleasesService. -->
<app-feature-release-window *ngIf="isHeader"></app-feature-release-window>
<app-release-history-drawer *ngIf="isHeader"></app-release-history-drawer>

<!-- Global: floating AI chat assistant (gated by `ai_assistant_leads` flag + lead permission) -->
<app-ai-assistant-fab *ngIf="isHeader"></app-ai-assistant-fab>

<!-- Global: internal office chat launcher (gated by the `chat` flag + an authenticated session) -->
<app-chat-launcher *ngIf="isHeader"></app-chat-launcher>

<ng-container *ngIf="!isHeader">
  <router-outlet></router-outlet>
</ng-container>
